module.exports = __webpack_public_path__ + "img/grxx_zt_3.e41876da.svg";